import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import './premium.css'
import './interior.css'
import './i18n.css'
import './i18n'
import App from './App.tsx'

// Prerendered snapshots (scripts/prerender.mjs) ship static SEO tags for
// crawlers. Once the app boots, React/Helmet re-creates them, so remove the
// static copies to avoid duplicate <title>/<meta> and stale titles on
// client-side navigation.
if (document.documentElement.hasAttribute('data-prerendered')) {
  document.head
    .querySelectorAll(
      'title, meta[name="description"], meta[name="keywords"], meta[name="robots"], meta[property^="og:"], meta[name^="twitter:"], link[rel="canonical"], link[rel="alternate"][hreflang], meta[property="og:locale:alternate"], script[type="application/ld+json"]',
    )
    .forEach((el) => el.remove())
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
)
